<template>
<v-container>
    <v-row justify="space-between" align="center" class="mb-6">
  <v-col cols="12" md="4" class="d-flex  align-center" style="gap: 8px;">
    <v-btn color="success" :to="{ name: 'uploadImages' }">Image Upload With Roll Number</v-btn>
    <v-btn color="success" :to="{ name: 'uploadImage' }">Image Upload Drag&Drop</v-btn>
  </v-col>
    </v-row>
    </v-container>
</template>